import {
  animate,
  group,
  query,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const rightOutletTransitions = [
  trigger('rightOutletTransitions', [
    transition('2 => 1, 3 => 1, 4 => 1, void => *', [
      query(
        ':enter .page-wrapper',
        sequence([
          style({ opacity: 0 }),
          animate('800ms ease', style({ opacity: 1 })),
        ]),
        { optional: true }
      ),
    ]),
    transition('1 => *, 2 => 3, 2 => 4, 3 => 4', [
      group([
        query(
          ':enter > .image-wrapper',
          [
            style({ opacity: 0 }),
            animate('800ms 200ms ease', style({ opacity: 1 })),
          ],
          { optional: true }
        ),
        query(
          ':enter > :not(.image-wrapper)',
          sequence([
            query('.close-btn', style({ opacity: 0 }), { optional: true }),
            style({ opacity: 0, transform: 'translateX(1rem)' }),
            animate(
              '800ms ease',
              style({ opacity: 1, transform: 'translateX(0)' })
            ),
          ]),
          { optional: true }
        ),
      ]),
    ]),
    transition('4 => 3, 3 => 2, 4 => 2', [
      query(
        ':enter > *',
        sequence([
          query('.close-btn', style({ opacity: 0 }), { optional: true }),
          style({ opacity: 0, transform: 'translateX(-2rem)' }),
          animate(
            '800ms ease',
            style({ opacity: 1, transform: 'translateX(0)' })
          ),
        ]),
        { optional: true }
      ),
    ]),
  ]),
];
